export const IfConstants = {
    IF_SCHEME_LIST_REQUEST: 'IF_SCHEME_LIST_REQUEST',
    IF_GET_ROLE_LIST:'IF_GET_ROLE_LIST',
    IF_CONFIG_FILTERS: "IF_CONFIG_FILTERS",
};